/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllOperationEntityTypes,
    GetAllFactoriesByFactoryType,
    GetAllAdjustmentTypes,
    GetProductCategoties,
    GetProductDetails,
    GetAvailableStockQuantity,
    SaveStockAdjustments,
    GetStockAdjustmentDetails,
    GetStockAdjustmentByStockAdjustmentID,
    UpdateStockAdjustmentQuantity,
    RemoveStockAdjustment
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByFactoryType(groupID, factoryType) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByFactoryType', 'groupID=' + parseInt(groupID) + '&factoryType=' + parseInt(factoryType));
    return response.data;
}

async function GetAllOperationEntityTypes() {
    const response = await CommonGet('/api/StockAdjustment/GetAllOperationEntityTypes', null);
    return response.data;
}

async function GetAllAdjustmentTypes() {
    const response = await CommonGet('/api/StockAdjustment/GetAllAdjustmentTypes', null);
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductCategoryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAvailableStockQuantity(groupID, factoryID, productCategoryID, productID) {
    const response = await CommonGet('/api/StockAdjustment/GetAvailableStockQuantity', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID) + '&productCategoryID=' + parseInt(productCategoryID) + '&productID=' + parseInt(productID));
    return response.data;
}

async function SaveStockAdjustments(data) {
    const response = await CommonPost('/api/StockAdjustment/SaveStockAdjustments', null, data);
    return response;
}

async function GetStockAdjustmentDetails(data) {
    const response = await CommonPost('/api/StockAdjustment/GetStockAdjustmentDetails', null, data);
    return response.data;
}

async function GetStockAdjustmentByStockAdjustmentID(stockAdjustmentID) {
    const response = await CommonGet('/api/StockAdjustment/GetStockAdjustmentByStockAdjustmentID', 'stockAdjustmentID=' + parseInt(stockAdjustmentID));
    return response.data;
}

async function UpdateStockAdjustmentQuantity(data) {
    const response = await CommonPost('/api/StockAdjustment/UpdateStockAdjustmentQuantity', null, data);
    return response;
}

async function RemoveStockAdjustment(stockAdjustmentID, modifiedBy) {
    const response = await CommonGet('/api/StockAdjustment/RemoveStockAdjustment', 'stockAdjustmentID=' + parseInt(stockAdjustmentID) + '&modifiedBy=' + parseInt(modifiedBy));
    return response;
}
